import styled from 'styled-components';
import { breakpoints } from '@theme/breakpoints';
import { rem } from 'polished';

export const StyledColorCardList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: var(--font-geomanist);
  text-align: center;
  padding: 3rem;

  @media (${breakpoints.tablet}) {
    max-width: ${rem(1200)};
    margin: 0 auto;
  }

  @media (${breakpoints.mobilelgMax}) {
    padding-top: 0;
    padding-bottom: 0;
  }

  h2 {
    font-family: var(--font-geomanist);
    font-weight: 700;
    font-size: 36px;
    line-height: 27px;
    text-align: center;
    vertical-align: middle;
    color: #0000ff;
    margin-top: 1.5rem;
    margin-bottom: 2.5rem;
  }

  .cards {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 22px;

    @media (${breakpoints.desktop}) {
      flex-direction: row;
    }
  }

  p {
    font-family: var(--font-geomanist);
    font-weight: 200;
    font-size: 16px;
    line-height: 21px;
    text-align: center;
    vertical-align: middle;
    max-width: 900px;
    margin-top: 2rem;
    color: black;
  }
`;
